/**
 * Created by xiajing on 2018/1/17.
 */
import * as types from '../constants/ActionTypes'

let receiveTxfitUrl = (data) => {
    return {
        type: types.RECEIVE_TXFIT_URL,
        payload: {
            sendurl: data.sendurl,
            playurl: data.playurl
        }
    }
}

let sendedTxfitUrlToBackgroud = () => {
    return {
        type: types.SENDED_TXFIT_URL_TO_BACKGROUD
    }
}

export default {
    receiveTxfitUrl,
    sendedTxfitUrlToBackgroud
}